import 'iframe-resizer';

(function ($) {
  /**
   * On Symbiosy template, we are using embed from other website.
   * We need to apply script, which helps us to adjust better responsivity.
   *
   * Source: https://github.com/davidjbradshaw/iframe-resizer
   */
  if ($('body').hasClass('page-template-template-symbiotic-building')) {
    iFrameResize({}, '#symbiosy-embed');
  }

  if ($('body').hasClass('page-template-template-wizard')) {
    iFrameResize({}, '#wizard-embed');
  }
})(jQuery);
